import { ACCOUNT_TYPES } from "../resources/enums"
import { DefaultRoute } from "../router/routes"

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const getUserData = () => JSON.parse(localStorage.getItem("userData"))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === "admin") return DefaultRoute
  if (userRole === "client") return "/access-control"
  return "/login"
}

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#1B30531a", // for option hover bg-color
    primary: "#1B3053", // for selected option bg-color
    neutral10: "#1B3053", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed" // for input hover border-color
  }
})

export const years = () => {
  const year = new Date().getFullYear() - 18
  const yearList = []
  for (let index = 0; index < 81; index++) {
    yearList.push({ id: year - index, name: `${year - index}` })
  }
  return yearList
}

export const toTime = (seconds) => {
  let minute = Math.floor((seconds / 60) % 60)
  minute = minute < 10 ? `0${ minute }` : minute
  let second = seconds % 60
  second = second < 10 ? `0${ second }` : second

  return `${ minute }:${ second }`
}

export const getMainAccount = (accounts = []) => {
  const account = accounts?.filter(item => item.typeAccountId === ACCOUNT_TYPES.MAIN)
  if (account?.length > 0) {
    return account
  }

  return []
}

export const validateOnlyNumber = (event) => {
  const tecla = event.key
  if (['+', 'e', ',', '-'].includes(tecla)) {
    event.preventDefault()
  }
}

// ** Formato de importes: coma como separador de miles, punto como decimal.
//
// El backend devuelve los saldos como cadena sin separar ("3595502.00"), que a partir de
// cuatro cifras es difícil de leer. Se normaliza aquí para que todas las pantallas usen
// el mismo formato en vez de repetir toLocaleString suelto.
//
// Acepta número o cadena. Si el valor no es interpretable devuelve la cadena original,
// que es preferible a mostrar "NaN" sobre un saldo.
export const parseAmount = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value !== 'string') return null

  // Se limpia todo menos dígitos, signo y separadores; las comas de miles se descartan.
  const cleaned = value.replace(/[^\d.,-]/g, '').replace(/,/g, '')

  // Sin ningún dígito no hay importe que formatear. Hace falta comprobarlo antes de
  // Number(): Number('') y Number(' ') son 0, así que una cadena vacía o un texto sin
  // cifras acabarían mostrándose como "0.00", que es un saldo inventado.
  if (!/\d/.test(cleaned)) return null

  const parsed = Number(cleaned)

  return Number.isFinite(parsed) ? parsed : null
}

export const formatMoney = (value, { decimals = 2 } = {}) => {
  const parsed = parseAmount(value)

  if (parsed === null) return value ?? ''

  return parsed.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
}

// ** Iniciales para avatares sin foto.
//
// Dos letras: nombre + apellido. Vuexy toma una inicial por palabra, así que un
// "Ana Maria Gomez" le salía "AMG" en el navbar mientras la card del sidebar mostraba
// "AG". Se centraliza aquí para que ambos avatares coincidan.
//
// Sin nombre cae al correo, y si tampoco hay, a un guion: un avatar vacío se lee como
// un fallo de render, no como un usuario sin datos.
export const getInitials = (user) => {
  const first = user?.name?.trim().split(/\s+/)[0]?.[0] ?? ''
  const last = user?.lastName?.trim().split(/\s+/)[0]?.[0] ?? ''
  const initials = `${first}${last}`.toUpperCase()

  if (initials) return initials

  return user?.email?.trim()?.[0]?.toUpperCase() ?? '–'
}
